<!-- 支付方式 -->
<template>
  <ClientOnly>
    <el-dialog :title="$t('cards.pay_with')" :model-value="dialogVisible" :width="588" @close="emits('update:visible', false)">
      <div>
        <div :class="$style.list">
          <div
            v-for="(card, index) in cardList"
            :key="index"
            :class="[$style.card, { [$style.active]: card.cardId === chooseCardId }]"
            @click="selectCard(card)"
          >
            <img v-if="card.iconUrl" :src="card.iconUrl" alt="Card Icon" :class="$style.cardIcon" />
            <div>{{ card.cardNumber }}</div>
            <div style="margin-left: auto" :class="$style.deleteAction">
              <el-popconfirm 
                width="300" 
                :title="$t('cards.home.remove_card_content')"
                :confirm-button-text="$t('cards.home.remove_confirm')"
                :cancel-button-text="$t('common.cancel')"
                @confirm="deleteCard(card)">
                <template #reference>
                  <el-button
                    text
                    circle
                    :type="card.cardId === chooseCardId ? 'primary' : 'default'"
                    style="width: 34px"
                    @click="(e) => e.stopPropagation()"
                  >
                    <el-icon :size="18"><Delete /></el-icon>
                  </el-button>
                </template>
              </el-popconfirm>
            </div>
            <div v-if="card.cardId === chooseCardId" :class="$style.iconCheck">
              <r-icon name="icon-checkmark" :size="12" style="font-size: 12px" />
            </div>
          </div>
        </div>
        <div :class="$style.footer">
          <el-button @click="emits('openAddCard')" v-if="cardList.length && cardList.length <= bindLimit - 1">{{
            $t('cards.home.add_card')
          }}</el-button>
          <el-button type="primary" @click="submitCard">{{ $t('common.confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </ClientOnly>
</template>
<script setup lang="ts">
import { Delete } from '@element-plus/icons-vue';
import { CardI } from '~/utils/cards/type';
import { deleteCard_post } from '~/api/cards/trade';
const props = defineProps(['visible', 'cardId', 'cardList', 'bindLimit']);
const emits = defineEmits(['update:visible', 'update:cardId', 'openAddCard', 'afterDelete']);

const dialogVisible = ref(props.visible); // 控制添加卡片模态框的显示隐藏

const chooseCardId = ref();

const selectCard = (card: CardI) => {
  chooseCardId.value = card.cardId;
};

function submitCard() {
  emits('update:cardId', chooseCardId.value);
  emits('update:visible', false);
}

const deleteLoading = ref(false);
function deleteCard(card: CardI) {
  deleteLoading.value = true;
  
  deleteCard_post({ data: { cardId: card.cardId } }).then((res) => {
    if (res?.success){
      
      // 如果删除的是当前选中的卡片，重置为第一张
      const deletedCardList = props.cardList.filter((i:any) => i.cardId !== card.cardId);
      if(card.cardId === chooseCardId.value){
        chooseCardId.value = deletedCardList?.[0]?.cardId;
      }
      emits('afterDelete', card.cardId);
    }
  }).finally(()=>{
    deleteLoading.value = false;
  });
}

watch(
  () => props.visible,
  (newVisible) => {
    dialogVisible.value = newVisible;
  }
);

// 父组件更新任意值，chooseCardId都重置
watch(
  [() => props.cardId, () => props.visible],
  () => {
    if (props.cardId && props.cardId !== chooseCardId.value) {
      chooseCardId.value = props.cardId;
    }
  },
  { immediate: true }
);
</script>

<style lang="less" module>
.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0px 16px;
  margin-bottom: 10px;
  cursor: pointer;
  height: 64px;
  border-radius: 8px;
  background: rgba(249, 251, 253, 1);
  border: 1px solid rgba(249, 251, 253, 1);
  overflow: hidden;

  color: var(--color-p2p-text-primary);
  font-weight: 430;
  font-size: 14px;
  transition: all 0.3s;
  &.active {
    background: rgba(0, 181, 181, 0.1);
    border: 1px solid rgba(0, 181, 181, 1);
  }
}
.iconCheck {
  position: absolute;
  right: 0;
  top: 0;
  color: #ffffff;
  width: 20px;
  height: 20px;
  overflow: hidden;
  & > i {
    position: absolute;
    z-index: 10;
    color: #ffffff;
    font-size: 12px;
    right: 0;
  }
  &::before {
    overflow: hidden;
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 20px 20px 0;
    border-color: transparent #00b5b5 transparent transparent;
  }
}
.cardIcon {
  width: 32px;
  height: 26px;
  margin-right: 8px;
  object-fit: contain;
}
.footer {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  margin-top: 40px;
  :global {
    .el-button {
      height: 44px;
      flex-grow: 1;
    }
  }
}
</style>
